import { useTranslation } from 'react-i18next';

const CONTACT_EMAIL = 'calendar@togaphotos.com';

/* Section 05: a short colophon with the subscription advice and the contact address. */
export function AboutCard() {
  const { t } = useTranslation('public');
  return (
    <section aria-labelledby="about-heading">
      <div className="section-head">
        <h2 id="about-heading" className="m-0">{t('about.title')}</h2>
      </div>
      <p className="m-0 mt-4 text-sm leading-relaxed text-ink-2">
        {t('about.subscription')}
      </p>
      <p className="m-0 mt-4 text-sm">
        <span className="kicker">{t('about.contact')}</span>{' '}
        <a href={`mailto:${CONTACT_EMAIL}`} className="text-ink underline decoration-1 underline-offset-4 hover:text-accent-text">
          {CONTACT_EMAIL}
        </a>
      </p>
    </section>
  );
}
